module.exports = __webpack_public_path__ + "static/sapin-sapin-da7a5f9a5d23bf6cd9176c58f9355fbc.jpg";